<div class="container content">
  <div class="center-element">
    <div class="col-md-12">
      <img src="/assets/logo-posso-agendar-borda-azul-desktop.svg" alt="Posso Agendar?" class="login-img hidden-xs" />
      <img src="/assets/logo-posso-agendar-borda-azul.svg" alt="Posso Agendar?" class="login-img visible-xs" />
      <h2 class="subtitle">Informe o email vinculado a sua conta para criar uma nova senha.</h2>
      <form [formGroup]="form" class="example-form" (submit)="sendCodeToEmail()">   
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Email</mat-label>
          <input type="email" matInput formControlName="email" placeholder="Email" />
          <mat-error *ngIf="form.get('email')?.hasError('email')"> - Insira um email válido. </mat-error>
        </mat-form-field>       
        <button mat-flat-button color="primary" type="submit" class="btEnviar">Enviar Código</button>
        <button mat-button  color="primary" (click)="goToUrl('login')" class="btVoltar">Voltar</button>
      </form>
    </div>
  </div>
</div>
